import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import Header from '../../../components/Header';
import { StyledSpan } from '../requests.styled';
import { RequestsTableCard, RequestsTableCardFooter } from '../requestsPage.styles';
import SearchGroup from '../../../components/Header/Search/SearchGroup';
import SearchGroupMobile from '../../../components/Header/Search/SearchGroupMobile';
import ChatsWhatsappTableView from './ChatsWhatsappTableView';
import PaginationFooter from '../../../components/shared/table/PaginationFooter';
import { Main, MainContainer } from '../request/resume/RequestResume';
import { subscribeMobileLayout } from '../../../utils/mobileViewport';
import { listWhatsappChats, listWhatsappMessages } from '../../../services/operational/whatsappChats';

import ChatsWhatsappTableHeader from './ChatsWhatsappTableHeader';
import ChatWhatsappTableRow from './ChatWhatsappTableRow';
import ChatWhatsappPanel from './ChatWhatsappPanel';

const BREADCRUMB = [{ link: '', label: 'Operacional' }];
const POLL_MS = 4000;

const AREA_CONFIG = {
  solicita: {
    title: 'LucIA - Imobiliária',
    filterPlaceholder: 'Filtrar pretendente, usuário ou solicitação…',
    description:
      'Acompanhe as conversas do serviço LucIA SOLICITA. Clique em uma linha para ver as mensagens.',
  },
  coleta: {
    title: 'LucIA - Pretendentes',
    filterPlaceholder: 'Filtrar pretendente, telefone, usuário ou solicitação…',
    description:
      'Acompanhe as conversas da LucIA com os pretendentes no fluxo de coleta de dados/documentos. Clique em uma linha para ver as mensagens e intervir, se necessário.',
  },
};

const initialPagination = () => ({
  totalCount: 0,
  lastPage: 1,
  currentPage: 1,
  resultsPerPage:
    typeof localStorage !== 'undefined' && localStorage.getItem('resultsPerPageRequests')
      ? localStorage.getItem('resultsPerPageRequests')
      : '10',
  sort: '-updated_at',
  filter: '',
  date: {},
});

class ChatsWhatsappPage extends PureComponent {
  state = {
    requesting: false,
    isMobile: false,
    lines: [],
    pagination: initialPagination(),
    selectedUuid: null,
    selectedConversation: null,
    messages: [],
    loadingMessages: false,
    lastMessageId: 0,
  };

  pollTimer = null;

  get chatTipo() {
    return this.props.chatTipo === 'solicita' ? 'solicita' : 'coleta';
  }

  get areaConfig() {
    return AREA_CONFIG[this.chatTipo] || AREA_CONFIG.coleta;
  }

  componentDidMount() {
    this.unsubMobileLayout = subscribeMobileLayout((isMobile) => this.setState({ isMobile }));
    this.loadList();
  }

  componentWillUnmount() {
    if (this.unsubMobileLayout) this.unsubMobileLayout();
    this.stopPolling();
  }

  getToken = () => {
    const login = this.props.login;
    if (!login || !login.user || !login.user.token) return undefined;
    return login.user.token.access_token;
  };

  stopPolling = () => {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  };

  startPolling = () => {
    this.stopPolling();
    this.pollTimer = setInterval(() => {
      if (this.state.selectedUuid) {
        this.loadMessages(this.state.selectedUuid, true);
      }
    }, POLL_MS);
  };

  loadList = async () => {
    const token = this.getToken();
    if (!token) return;
    const areaTitle = this.areaConfig.title;
    this.setState({ requesting: true });
    try {
      const res = await listWhatsappChats(token, this.state.pagination, this.chatTipo);
      if (res.status === 401) {
        this.props.history.push('/auth');
        return;
      }
      if (res.status >= 400) {
        toastr.error(areaTitle, (res.data && res.data.message) || 'Não foi possível carregar os chats.');
        this.setState({ requesting: false });
        return;
      }
      const p = res.data.pagination || {};
      this.setState({
        requesting: false,
        lines: res.data.data || [],
        pagination: {
          ...this.state.pagination,
          totalCount: p.total,
          lastPage: p.last_page,
          currentPage: p.current_page,
          resultsPerPage: String(p.per_page),
        },
      });
    } catch (e) {
      this.setState({ requesting: false });
      toastr.error(areaTitle, 'Erro ao carregar chats.');
    }
  };

  loadMessages = async (uuid, incremental = false) => {
    const token = this.getToken();
    if (!token || !uuid) return;
    const areaTitle = this.areaConfig.title;

    if (!incremental) {
      this.setState({ loadingMessages: true, messages: [], lastMessageId: 0 });
    }

    try {
      const sinceId = incremental ? this.state.lastMessageId : 0;
      const res = await listWhatsappMessages(token, uuid, { sinceId });
      if (res.status === 401) {
        this.props.history.push('/auth');
        return;
      }
      if (res.status >= 400) {
        if (!incremental) {
          toastr.error(areaTitle, (res.data && res.data.message) || 'Não foi possível carregar as mensagens.');
        }
        this.setState({ loadingMessages: false });
        return;
      }

      const incoming = res.data.messages || [];
      const conversation = res.data.conversation || null;
      let messages = incremental ? [...this.state.messages] : incoming;
      if (incremental && incoming.length > 0) {
        const ids = new Set(messages.map((m) => m.id));
        incoming.forEach((m) => {
          if (!ids.has(m.id)) messages.push(m);
        });
      }
      messages.sort((a, b) => (a.id || 0) - (b.id || 0));
      const lastMessageId = messages.reduce((max, m) => Math.max(max, m.id || 0), 0);

      this.setState({
        loadingMessages: false,
        messages,
        lastMessageId,
        selectedConversation: conversation
          ? { ...this.state.selectedConversation, ...conversation }
          : this.state.selectedConversation,
      });
    } catch (e) {
      if (!incremental) {
        this.setState({ loadingMessages: false });
        toastr.error(areaTitle, 'Erro ao carregar mensagens.');
      }
    }
  };

  onSelectRow = (line) => {
    const uuid = line.uuid;
    this.setState(
      {
        selectedUuid: uuid,
        selectedConversation: line,
      },
      () => {
        this.loadMessages(uuid, false);
        this.startPolling();
      },
    );
  };

  onBackToList = () => {
    this.stopPolling();
    this.setState(
      {
        selectedUuid: null,
        selectedConversation: null,
        messages: [],
        loadingMessages: false,
        lastMessageId: 0,
      },
      this.loadList,
    );
  };

  onConversationUpdated = (conversation) => {
    this.setState((prev) => ({
      selectedConversation: conversation,
      lines: prev.lines.map((row) => (row.uuid === conversation.uuid ? { ...row, ...conversation } : row)),
    }));
  };

  refreshMessages = () => {
    const uuid = this.state.selectedUuid;
    if (uuid) {
      this.loadMessages(uuid, false);
    }
  };

  onMessageSent = (payload) => {
    const message = payload.message;
    const conversation = payload.conversation;
    const uuid = this.state.selectedUuid;
    if (message) {
      this.setState(
        (prev) => ({
          messages: [...prev.messages, message],
        }),
        () => {
          if (uuid) this.loadMessages(uuid, true);
        },
      );
    }
    if (conversation) {
      this.onConversationUpdated(conversation);
    }
    this.loadList();
  };

  onFilter = (text) => {
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, filter: text, currentPage: 1 },
      }),
      this.loadList,
    );
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, currentPage: page },
      }),
      this.loadList,
    );
  };

  onChangeResultsperPage = (perPage) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('resultsPerPageRequests', String(perPage));
    }
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, resultsPerPage: String(perPage), currentPage: 1 },
      }),
      this.loadList,
    );
  };

  render() {
    const {
      requesting,
      isMobile,
      lines,
      pagination,
      selectedUuid,
      selectedConversation,
      messages,
      loadingMessages,
    } = this.state;

    const showingChat = Boolean(selectedUuid && selectedConversation);
    const { title, filterPlaceholder, description } = this.areaConfig;
    const showTelefoneColumn = this.chatTipo !== 'solicita';

    return (
      <Main>
        <Header title={title} breadcrumb={BREADCRUMB} actualLink={title} />
        <MainContainer>
            {showingChat ? (
              <ChatWhatsappPanel
                token={this.getToken()}
                chatTipo={this.chatTipo}
                conversation={selectedConversation}
                messages={messages}
                loadingMessages={loadingMessages}
                onBack={this.onBackToList}
                onConversationUpdated={this.onConversationUpdated}
                onMessageSent={this.onMessageSent}
                onRefreshMessages={this.refreshMessages}
              />
            ) : (
              <Fragment>
                {isMobile ? (
                  <SearchGroupMobile setFilter={this.onFilter} filterPlaceholder={filterPlaceholder} />
                ) : (
                  <SearchGroup setFilter={this.onFilter} filterPlaceholder={filterPlaceholder} />
                )}

                <StyledSpan style={{ display: 'block', marginBottom: 12 }}>{description}</StyledSpan>

                <RequestsTableCard>
                  <ChatsWhatsappTableView
                    loading={requesting}
                    lines={lines}
                    chatTipo={this.chatTipo}
                    renderHeader={() => (
                      <ChatsWhatsappTableHeader
                        chatTipo={this.chatTipo}
                        showTelefoneColumn={showTelefoneColumn}
                      />
                    )}
                    renderLine={(line, index) => (
                      <ChatWhatsappTableRow
                        key={line.uuid}
                        line={line}
                        index={index}
                        length={lines.length}
                        chatTipo={this.chatTipo}
                        selected={false}
                        onRowClick={this.onSelectRow}
                        showTelefoneColumn={showTelefoneColumn}
                      />
                    )}
                  />
                  <RequestsTableCardFooter>
                    <PaginationFooter
                      pagination={pagination}
                      changePage={this.onChangePage}
                      changeMaxResults={this.onChangeResultsperPage}
                      allowMaxPerPage
                    />
                  </RequestsTableCardFooter>
                </RequestsTableCard>
              </Fragment>
            )}
          </MainContainer>
      </Main>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default connect(mapStateToProps)(ChatsWhatsappPage);
